// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Pnrc","title":"Header_title__1QGNo","side":"Header_side__5jg-i"};